export enum QuoteTypeOfBuy {
  InventoryBuy = 'inventoryBuy',
  ProjectBid = 'projectBid',
  ProjectBuy = 'projectBuy',
}
